import { connect } from 'react-redux'
import { HomePage as Page } from './HomePage'
import { selectGroupsList } from '../../selectors/groups'

const mapStateToProps = (state) => ({
  groupsList: selectGroupsList(state),
  groupsLoading: state.groups.isLoading,
  groupsLoaded: state.groups.isLoaded,
})

export const HomePage = connect(mapStateToProps)(Page)
